export default __webpack_public_path__ + "static/media/locked.21e21d7e.png";